import normalizeImage from "../base/ImageBase"

interface TextImageProps {
  type: string;
  sectionId: string;
  colorScheme: string;
  title: string;
  subtitle: string;
  body: any[];
  ctaPrimary: any;
  ctaSecondary: any;
  image: any;
  preTitle: any;
  textAlign?: string;
}

interface NormalizedTextImage extends Omit<TextImageProps, 'image'> {
  image: ReturnType<typeof normalizeImage>;
}

const TextImage = ({
  type,
  sectionId,
  colorScheme,
  title,
  subtitle,
  body,
  ctaPrimary,
  ctaSecondary,
  image,
  preTitle,
  textAlign = 'left'
}: TextImageProps): NormalizedTextImage => {
  const normalizedImage = normalizeImage(image);

  const normalizedData: NormalizedTextImage = {
    type,
    sectionId,
    colorScheme,
    title,
    subtitle,
    body,
    ctaPrimary,
    ctaSecondary,
    image: normalizedImage,
    preTitle,
    textAlign
  }

  return normalizedData
}

export default TextImage
